export default {
  mobile_app_average_order_value: {
    label: 'VOC via Aplicație',
  },
  mobile_app_gmv: {
    label: 'Vânzări Aplicație',
  },
  mobile_app_gmv_percentage: {
    label: '% Venituri via Aplicație',
  },
  mobile_app_downloads: {
    label: 'Descărcări',
  },
  mobile_app_orders_count: {
    label: 'Comenzi Aplicație',
  },
  name: {
    label: 'Restaurant',
  },
  mobile_app_released_at: {
    label: 'Dată lansare',
  },
  title: 'Director restaurante',
};
